<template>
	<section>
		<Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword" :cartnum="cartnum"></Header>
		<div class="layui-main">
			<el-row class="tac flex ju-be">
				<el-col :span="3">
					<el-menu :default-openeds="openeds" :default-active="type" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
						<el-submenu index="1">
							<template slot="title">
								
									<span slot="title" class="title">订单中心</span>
								
							</template>
							<el-menu-item-group>
								<el-menu-item index="1-0" @click="changetab('1-0')">
									<div style="line-height: 40px; display: inline-block; position: relative;">
										{{levelid>1?"审核草稿单":"我的草稿订单"}}<span class="layui-badge" style="    position: absolute; right:-17px; top: 0;     border-radius: 50%; top: 3px;    background-color: #f19d15;" v-if="indexData.user.draftauditnum>0">{{indexData.user.draftauditnum}}</span>
									</div>
								</el-menu-item>
								<el-menu-item index="1-1" @click="changetab('1-1')">我的订单</el-menu-item>
								<el-menu-item index="1-4" @click="changetab('1-4')">退款订单</el-menu-item>
								<el-menu-item index="1-2" @click="changetab('6-7')" v-if="levelid==2||levelid==3">我的账单</el-menu-item>
								<el-menu-item index="1-3" @click="changetab('1-3')">回收站</el-menu-item>
								<el-menu-item index="6-9" v-if="levelid==1&&indexData.user.companyid!=0" @click="changetab('6-9')">签约商品</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="2">
							<template slot="title">
								<span slot="title" class="title">账户设置</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="2-1" @click="changetab('2-1')">个人资料</el-menu-item>
								<el-menu-item index="2-2" @click="changetab('2-2')">修改密码</el-menu-item>
								<el-menu-item index="2-3" @click="changetab('2-3')">收藏商品</el-menu-item>
								<el-menu-item index="2-4" @click="changetab('2-4')">收货地址</el-menu-item>
								<el-menu-item index="2-5" @click="changetab('2-5')">发票管理</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="3">
							<template slot="title">
								<span slot="title" class="title">我的钱包</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="changetab('3-1')">优惠券</el-menu-item>
								<el-menu-item index="3-2" @click="changetab('3-2')">我的积分</el-menu-item>
								<el-menu-item index="3-3" @click="changetab('3-3')">积分订单</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="4">
							<template slot="title">
								<span slot="title" class="title">客户服务</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="4-1">
									<a href="/page/3.html" target="_blank">售后服务</a>
								</el-menu-item>
								<el-menu-item index="4-2">
									<a href="/page/2.html" target="_blank">联系我们</a>
								</el-menu-item>
								<el-menu-item index="4-3">
									<a href="/page/10.html" target="_blank">常见问题</a>
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="5" v-if="levelid==3">
							<template slot="title">
								<span slot="title" class="title">子公司</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="5-1" @click="changetab('5-1')">授信数据</el-menu-item>
								<el-menu-item index="5-2" @click="changetab('5-2')">订单数据</el-menu-item>
								<el-menu-item index="5-3" @click="changetab('5-3')">结算数据</el-menu-item>
								<el-menu-item index="5-4" @click="changetab('5-4')">企业管理</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="6" v-if="levelid==2||levelid==3">
							<template slot="title">
								<span slot="title" class="title">综合下单功能</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="6-1" @click="changetab('6-1')" v-if="levelid==2">子账号管理</el-menu-item>
								<el-menu-item index="6-2" @click="changetab('6-2')" v-if="levelid==2">部门管理</el-menu-item>
								<el-menu-item index="6-3" @click="changetab('6-3')" v-if="levelid==2">授信管理</el-menu-item>
								<el-menu-item index="6-4" @click="changetab('6-4')">快速下单</el-menu-item>
								<el-menu-item index="6-5" @click="changetab('6-5')">批量询价</el-menu-item>
								<el-menu-item index="6-6" @click="changetab('6-6')">我的询价单</el-menu-item>
								<el-menu-item index="6-7" @click="changetab('6-7')">待结算订单</el-menu-item>
								<el-menu-item index="6-8" @click="changetab('6-8')">结算记录</el-menu-item>
								<el-menu-item index="6-9" @click="changetab('6-9')">签约商品</el-menu-item>
								<el-menu-item index="6-10" @click="changetab('6-10')">推荐商品</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</el-menu>
				</el-col>
				<el-col :span="20" class="content">
					<cgOrdeer v-if="type=='1-0'" :now_status="orderstatus" :levelid="levelid"></cgOrdeer>
					<Ordeer v-if="type=='1-1'" :now_status="orderstatus" :levelid="levelid"></Ordeer>
					<recycleBin v-if="type=='1-3'"></recycleBin>
					<RefundOrder v-if="type=='1-4'"></RefundOrder>
					<Ziliao v-if="type=='2-1'"></Ziliao>
					<UpdatePwd v-if="type=='2-2'"></UpdatePwd>
					<CollectGoods v-if="type=='2-3'"></CollectGoods>
					<Address v-if="type=='2-4'"></Address>
					<Invoice v-if="type=='2-5'"></Invoice>
					<OrderDetail v-if="type=='detail'" :orderno="orderno" :orderType="orderType" :isedit="isedit"></OrderDetail>
					<Coupons v-if="type=='3-1'"></Coupons>
					<Jifen v-if="type=='3-2'"></Jifen>
					<JifenOrder v-if="type=='3-3'"></JifenOrder>
					<SonShouxin v-if="type=='5-1'"></SonShouxin>
					<SonOrder v-if="type=='5-2'"></SonOrder>
					<SonJiesuan v-if="type=='5-3'"></SonJiesuan>
					<Company v-if="type=='5-4'"></Company>
					<SonAccount v-if="type=='6-1'"></SonAccount>
					<Department v-if="type=='6-2'"></Department>
					<QyShouxin v-if="type=='6-3'"></QyShouxin>
					<QuickOrder v-if="type=='6-4'"></QuickOrder>
					<BatchOrder v-if="type=='6-5'"></BatchOrder>
					<askOrder v-if="type=='6-6' "></askOrder>
					<AwaitOrder v-if="type=='6-7'"></AwaitOrder>
					<LogOrder v-if="type=='6-8'"></LogOrder>
					<qianyue v-if="type=='6-9'"></qianyue>
					<RecommendGoods v-if="type=='6-10'"></RecommendGoods>
					<div v-if="type==''">
						<div class="user-main">
							<div class="clearfix flex">
								<div class="userinfo">
									<div class="touxiang">
										<img :src="userInfo.headimgurl || '/static/images/avatar.jpg'" />
									</div>
									<div class="name">{{userInfo.username}}</div>
									<div class="lev center">
										<!-- <img src="/static/images/ykhy.png" /> -->
										<div v-if="levelid==1" class="usertype">游客会员</div>
										<div v-if="levelid==2" class="usertype">企业用户</div>
										<div v-if="levelid==3" class="usertype">集团用户</div>
									</div>
								</div>
								<div class="user-order">
									<div class="hd flex ju-be">
										<span>我的订单</span>
										<span class="color-primary" v-if="levelid!=1">合同有效期：{{resorder.timefrom}}-{{resorder.timeto}}</span>
										<span class="color-primary" v-if="levelid!=1">授信余额:{{(resorder.authmoney-resorder.authused).toFixed(2)}}</span>
										<el-button type="primary" plain @click="qiandaoVisible=true">{{jifenobj.sign==0?'签到':'已签到'}}</el-button>
									</div>
									<div class="bd">
										<ul class="clearfix clearlist">
											<li v-for="(item,index) in orderNumber" :key="index">
												<a href="javascript:;" @click="goOrderlist(item.status)">
													<div class="icon">
														<i :class="item.icon"></i>
														<span class="layui-badge" v-if="item.num">{{item.num}}</span>
													</div>
													<div class="tit">{{item.name}}</div>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="clearfix flex">
							</div>
							<div class="clearfix flex">
								<div class="qianbao">
									<div class="qhd">
										<div class="tit">我的钱包</div>
									</div>
									<div class="bd">
										<ul class="clearlist clearfix">
											<li @click="type='3-2'">
												<div class="num">{{jifenobj.balance}}</div>
												<div class="txt">我的积分</div>
											</li>
											<li @click="type='3-1'">
												<div class="num">{{yhjnum}}</div>
												<div class="txt">优惠券</div>
											</li>
										</ul>
									</div>
								</div>

								<div class="liulan">
									<div class="qhd">
										<div class="tit">我的收藏</div>
										<div class="more">
											<a href="javascript:;" @click="type='2-3'">
												更多
												<i class="iconfont icon-right"></i>
											</a>
										</div>
									</div>
									<div class="bd">
										<ul class="clearlist clearfix center">
											<li v-for="(item,index) in shoucanggoods.data" :key="index" class="center">
												<a :href="'#/goodsdetail?id='+item.tid" target="_blank">
													<img :src="item.indexpic" />
												</a>
											</li>
										</ul>
									</div>
								</div>
								<div class="liulan">
									<div class="qhd">
										<div class="tit">积分商城</div>
										<div class="more">
											<a href="/giftmall.html">
												更多
												<i class="iconfont icon-right"></i>
											</a>
										</div>
									</div>
									<div class="bd">
										<ul class="clearlist clearfix center">
											<li v-for="(item,index) in jifengoods.data" :key="index" class="center">
												<a :href="'/gift/'+item.id+'.html'" target="_blank">
													<img :src="item.indexpic" />
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="suiji">
								<div class="hd flex">
									<div class="fl">根据浏览 猜你喜欢</div>
									<!-- <div class="fr"><a href="javascript:;" class="btn"><i class="iconfont icon-refresh"></i>换一换</a></div> -->
								</div>
								<div class="bd">
									<div class="cpgroup" style="margin-left: -15px;">
										<div class="bd">
											<ul class="clearlist clearfix">
												<li class="item" v-for="(item,index) in cainixihuan.data" :key="index">
													<a :href="'#/goodsdetail?id='+ item.id" target="_blank">
														<div class="img">
															<img :src="item.indexpic" />
														</div>
														<div class="tit ellipsis-2">{{item.title}}</div>
														<div class="price">
															<span class="xianjia">¥{{item.price}}</span>
														</div>
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="签到" :visible="qiandaoVisible" width="50%" center :before-close="closeqiandao">
			<Qiandao></Qiandao>
		</el-dialog>

		<Footer :indexData="indexData"></Footer>
	</section>
</template>

<script>
	import Header from '../components/header';
	import Footer from '../components/footer';
	import Ordeer from '../components/order';
	import cgOrdeer from '../components/cgorder';
	import QuickOrder from '../components/quickOrder';
	import BatchOrder from '../components/batchOrder';
	import AwaitOrder from '../components/awaitOrder';
	import AskOrder from '../components/askOrder';
	import LogOrder from '../components/logOrder';
	import Address from '../components/address';
	import Coupons from '../components/coupons';
	import Jifen from '../components/jifen';
	import OrderDetail from '../components/orderDetail';
	import Pingjia from '../components/pingjia';
	import JifenOrder from '../components/jifenOrder';
	import eventBus from '../../static/eventBus.js';
	import CollectGoods from '../components/collectGoods';
	import SonShouxin from '../components/son_shouxin';
	import SonOrder from '../components/son_order';
	import SonJiesuan from '../components/son_jiesuan';
	import SonAccount from '../components/son_account';
	import Ziliao from '../components/ziliao';
	import UpdatePwd from '../components/update_pwd';
	import QyShouxin from '../components/qy_shouxin';
	import Department from '../components/department';
	import qianyue from '../components/qianyue';
	import Company from '../components/company';
	import Invoice from '../components/invoice';
	import Qiandao from '../components/Qiandao';
	import recycleBin from '../components/recycleBin';
	import RecommendGoods from '../components/recommendGoods';
	import RefundOrder from '../components/refundOrder';
	export default {
		components: {
			Header,
			qianyue,
			recycleBin,
			Qiandao,
			RecommendGoods,
			RefundOrder,
			Invoice,
			Company,
			SonShouxin,
			SonOrder,
			SonJiesuan,
			SonAccount,
			Ziliao,
			UpdatePwd,
			Footer,
			Department,
			QyShouxin,
			Ordeer,
			QuickOrder,
			BatchOrder,
			Jifen,
			Pingjia,
			CollectGoods,
			AwaitOrder,
			AskOrder,
			LogOrder,
			Address,
			Coupons,
			OrderDetail,
			JifenOrder,
			cgOrdeer
		},
		iniect: ['reload'], //注入reload方法
		name: 'index',
		data() {
			return {
				openeds: ['1', '2', '3', '4', '5', '6'],
				cartnum: 0,
				qiandaoVisible: false,
				resorder: '',
				defaults: {
					dateArray: [] // 假设已签到的天数+1
				},
				jifen: false,
				orderno:'',
				orderType:'order',
				levelid: 1,
				jifenobj: {}, //积分信息
				jifengoods: [], //积分商品
				orderstatus: '',
				orderNumber: [], //订单数量
				yhjnum: 0, //优惠卷数量
				shoucanggoods: {}, //收藏的商品
				type: getParameterByName('type') || '',
				cainixihuan: {},
				userInfo: {
					headimgurl: '',
					username: ''
				},
				keyword: '',
			
				indexData: {
					index_cartnum: 0,
					user: {},
					index_shop_self: {
						adlist: [{
							url: '',
							src: ''
						}, {
							url: '',
							src: ''
						}]
					}
				},
				isedit:false
			};
		},
		methods: {
			closeqiandao() {
				this.qiandaoVisible = false;
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			changetab(type) {
				//console.log("type", type.split("-"));
				this.openeds = [type.split('-')[0]];
				this.type = type;
				this.$router.push(`/usercenter?type=${type}`);
			},
			goOrderlist(status) {
				this.orderstatus = status + '';
				this.type = '1-1';
				console.log('orderstatus', this.orderstatus);
			},
			async getordernum() {
				// let orderNumber = ajaxMethod("getOrderNumber", { guid: this.guid })
				let orderNumber = await this.$fetch('member/orderstatus');
				console.log('orderNumber', orderNumber);
				orderNumber = orderNumber.splice(0, 4);
				orderNumber.push({
					name: '全部订单',
					num: '',
					status: ''
				});
				let icon = [
					'iconfont icon-dfk',
					'iconfont icon-dfh',
					'iconfont icon-dsh',
					'iconfont icon-ywc',
					'iconfont icon-order'
				];

				for (let i = 0; i < orderNumber.length; i++) {
					orderNumber[i]['icon'] = icon[i];
				}

				this.orderNumber = orderNumber;
				console.log('获取到的订单数量', orderNumber);
			},
			async getjiFen() {
				//获取积分
				let jifen = await this.$fetch('member/balance', {
					body: {
						page: 1,
						type: 'account2'
					}
				});
				this.jifenobj = jifen;
				console.log('获取积分', jifen);
			},
			async qiandao() {
				this.$router.push('/test');
				return;
				if (this.jifenobj.sign == 1) {
					this.$message.error('您已签到，请明日再签到');
					return;
				}
				let res = await this.$fetch('member/sign', {
					body: {
						act: 'sign'
					}
				});
				if (res) {
					this.$message.success(`签到成功+ ${res}积分`);
				}
				this.getjiFen();
			},
			async getjiFengoods() {
				//获取积分商品
				let jifengoods = await this.$fetch('shop/giftlist', {
					body: {
						page: 1,
						pagesize: 3
					}
				});
				this.jifengoods = jifengoods;
				console.log('获取积分商品', jifengoods);
			},
			async getyhjnum() {
				//获取优惠券
				let yhjnum = await this.$fetch('member/couponlist', {
					body: {
						page: 1,
						type: 1
					}
				});
				this.yhjnum = yhjnum.total;
				console.log('获取优惠券', yhjnum);
			},
			async getshoucanggoods() {
				//获取收藏
				let shoucanggoods = await this.$fetch('member/favlist', {
					body: {
						page: 1,
						type: 1,
						act: 'list',
						pagesize: 3
					}
				});
				this.shoucanggoods = shoucanggoods;
				console.log('获取收藏', shoucanggoods);
			},

			async signLog() {
				let activedate = await this.$fetch('member/sign', {
					body: {
						month: new Date().getFullYear() + '' + (new Date().getMonth() + 1),
						act: 'history'
					}
				});
				for (let key in activedate) {
					this.defaults.dateArray.push(key - 2);
				}
			},
			async changeshnum(){
				this.indexData = await this.$fetch('Index/indexdata');
				this.levelid = this.indexData.user.levelid;
			}
		},

		async mounted() {
			this.levelid = JSON.parse(localStorage.jinruser).levelid;
			this.indexData = await this.$fetch('Index/indexdata');
			this.levelid = this.indexData.user.levelid;
			 eventBus.$on('cgback',()=>{
				 this.changetab('1-0');
				 console.log(1111111);
			 });
			 eventBus.$on('editorder',args => {
			 	this.isedit=args.isedit;
				console.log(args);
			 });
			eventBus.$on('my-event', args => {
				console.log(args.orderno);
				this.type = 'detail';
				this.orderno = args.orderno;
				this.orderType = args.orderType;
			});
			if (sessionStorage.user) {
				this.userInfo = JSON.parse(sessionStorage.user);
			}
			this.getordernum();
			this.getjiFengoods();
			this.getjiFen();
			this.getyhjnum();
			this.getshoucanggoods();
			await this.signLog();
			// 猜你喜欢
			this.cainixihuan = await this.$fetch('Shop/productlist', {
				body: {
					page: 1,
					pagesize: 8,
					guid: '',
					guess: 1
				}
			});
			eventBus.$on('changecarnum', data => {
				this.cartnum = data;
			});
			eventBus.$on('changeshnum', data => {
				
				this.changeshnum();
			});
			
			// 是否有待结算订单
			if (this.levelid != 1) {
				let resorder = await this.$fetch('order/logintip');
				let ordernum = resorder.ordernum;
				this.resorder = resorder;
				if (ordernum > 0) {
					this.$confirm('您当前有待结算订单，请尽快结算', '提示', {
							confirmButtonText: '去查看',
							cancelButtonText: '确定',
							type: 'warning'
						})
						.then(() => {
							this.type = '6-7';
						})
						.catch(() => {});
				}
			}
		}
	};
</script>


<style lang='scss'>
	.el-button--mini,
	.el-button--small {
		// margin-right: 10px;
	}

	.title {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
	}

	.tac {
		align-items: flex-start;

		.el-menu-item-group {
			ul {
				margin: 0;

				li {
					padding: 0 !important;
					min-width: 0;
					text-align: center;
					height: 40px;
					line-height: 40px;
				}
			}
		}

		.content {
			background: #fff;
			margin-top: 20px;
		}
	}

	.layui-main {
		width: 1470px !important;
		margin: auto;
	}

	.cpgroup .bd .item {
		margin-left: 5px;
	}

	.clearfix {
		justify-content: space-between;
	}

	.el-button--primary.is-plain {
		color: #fff !important;
	}

	div,
	ul,
	li,
	p,
	a {
		margin: 0;
		padding: 0;
		font: 14px/1.8 "Helvetica Neue", "microsoft yahei";
		box-sizing: border-box;
	}

	.checkin {
		margin: auto;
		width: 452px;
		background: #f90;
		border-radius: 10px;
		color: #fff;
		padding: 10px;

		ul {
			display: table;
			width: 100%;

			li {
				list-style: none;
			}
		}
	}

	.checkin .week li {
		display: table-cell;
		width: 14.28%;
		height: 50px;
		border-right: 1px solid #f90;
		background: #b25d06;
	}

	.calendarList li {
		display: table-cell;
		width: 14.28%;
		height: 50px;
		border-right: 1px solid #f90;
		border-bottom: 1px solid #f90;
		color: #b25d06;
	}

	.week li:nth-child(7n),
	.calendarList li:nth-child(7n) {
		border-right: none;
	}

	li.data-grey {
		color: #e9c530;
	}

	.clear {
		clear: both;
	}

	.clearfix:after {
		clear: both;
		font-size: 0;
		height: 0;
		display: block;
		visibility: hidden;
		content: " ";
		line-height: 0;
	}

	.title {
		height: 36px;
		line-height: 36px;
		font-size: 16px;
		margin-bottom: 10px;
	}

	.title p {
		float: left;
		line-height: 36px;
		font-size: 16px;
	}

	.title a {
		display: inline-block;
		float: right;
		height: 36px;
		width: 20%;
		line-height: 36px;
		text-align: center;
		background: #42941a;
		border-radius: 5px;
		color: #fff;
		text-decoration: none;
		font-size: 16px;
	}

	.checkin li {
		background: #fee684;
		float: left;
		padding: 10px;
		text-align: center;
	}

	li.able-sign {
		background: #e9c530;
	}

	li.checked {
		background: #fee684 url("/static/images/xiaolian.png") no-repeat center !important;
	}

	.mask {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.55);
		visibility: hidden;
		transition: all 0.25s ease;
	}

	.modal {
		background: #fff;
		width: 450px;
		height: 400px;
		border-radius: 10px;
		position: absolute;
		margin-top: -200px;
		margin-left: -225px;
		left: 50%;
		top: 50%;
		border: 5px solid #42941a;
		box-sizing: border-box;
		overflow: hidden;
		transform: translateY(-200%);
		transition: all 0.25s ease;
	}

	a.closeBtn {
		display: block;
		position: absolute;
		right: 10px;
		top: 5px;
		font-family: "simsun";
		font-size: 18px;
		text-decoration: none;
		font-weight: bolder;
		color: #333;
	}

	.trf {
		visibility: visible;
	}

	.trf .modal {
		transform: translateY(0);
	}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter.vue